import React from 'react'
import { Radio, UnderDevelopmentLabel } from '../../../../components'
import FormNew from './form-new'
import FormExist from './form-exist'

const ExportPopup = ({onClose, isMobile}) => {
  const [form, setForm] = React.useState({
    export_type: 'exist',
  })

  const updateForm = (e) => {
    console.log({e})
    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  const handleClose = (e) => {
    e.preventDefault()
    e.stopPropagation()

    onClose(false)
  }

  return (
    <div
      className="fixed left-0 top-0 w-full h-screen flex justify-center items-center"
      style={{zIndex: 900, background: 'rgba(0, 0, 0, 0.75)'}}
      onClick={handleClose}
    >
      <div className="container mx-auto" onClick={(e) => e.stopPropagation()}>
        <div className="lg:w-8/12 mx-auto p-5 lg:p-8 bg-white rounded">
          <h1 className="text-lg lg:text-3xl font-primary font-bold">Export to Program</h1>
          <div className="mt-4">
            <UnderDevelopmentLabel />
          </div>
          <hr className="mt-5 mb-5 lg:mb-10"/>
          <form>
            <div className="flex flex-wrap items-center mb-5 lg:mb-8">
              <Radio
                name="export_type"
                id="export_type1"
                label="Export to New Program"
                value="new"
                className="w-full lg:w-auto mb-3 lg:mb-0 mr-4"
                form={form}
                onChange={updateForm}
              />
              <Radio
                name="export_type"
                id="export_type2"
                label="Export to Existing Program"
                value="exist"
                className="w-full lg:w-auto "
                form={form}
                onChange={updateForm}
              />
            </div>

            {
              form.export_type === 'exist' && <>
                <FormExist handleClose={handleClose}/>
              </>
            }

            {
              form.export_type === 'new' && <>
                <FormNew handleClose={handleClose}/>
              </>
            }
          </form>
        </div>
      </div>
    </div>
  )
}

export { ExportPopup }
